// removed by extract-text-webpack-plugin
module.exports = {"day":"_3vhfYWwcE2a2zdgdftZg4g","active":"sP-8w30Kbv5uceKOCFQGs","disable":"_1dHOcbirPivrCqDLpULMjz","label":"_1jG8HFMvVt4u5qyU8s7tis","value":"_5rkaJvm0suDr9fimV5iey","point":"_2e3oHhbeB2iKKZ3Y-DslOF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/Day.scss
// module id = 1105
// module chunks = 0